module.exports = require("./../../_gen/openfl/errors/EOFError");